import { el } from 'redom';

const ALL_SELECTED_CLASS = 'all-selected';

class SelectAllButton {

  constructor(configuration) {

    this.allSelected = false;

    this.singleSelectNative = configuration.singleSelectNative;
    this.onChange = configuration.onChange;

    this.el = el('.single-select-select-all-button-main', {
      onclick: this.handleClickEvent.bind(this)
    }, 'Select all');

  }

  setAllSelected() {

    this.allSelected = true;

    this.el.classList.add(ALL_SELECTED_CLASS);

  }

  unsetAllSelected() {

    this.allSelected = false;

    this.el.classList.remove(ALL_SELECTED_CLASS);

  }

  handleClickEvent() {

    if (this.allSelected === true) {
      this.unsetAllSelected();
    } else {
      this.setAllSelected();
    }

    this.onChange(this.allSelected);

  }

  update() {

    if (this.singleSelectNative.determineAllSelected() === true) {

      if (this.allSelected === false) {
        this.setAllSelected();
      }

    } else {

      if (this.allSelected === true) {
        this.unsetAllSelected();
      }

    }

  }

}

export default SelectAllButton;